import React, { useState } from 'react';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

export type DuplicateRecord = {
  cnpj_fundo: string;
  subclasse: string;
  serie: string;
  quantidade: string;
  index: number;
};

export type DuplicateGroup = {
  key: string;
  records: DuplicateRecord[];
};

interface DuplicateRecordsModalProps {
  open: boolean;
  duplicateGroups: DuplicateGroup[];
  onConfirm: (selected: { [key: string]: number }) => void;
  onCancel: () => void;
  onKeepAll?: () => void;
}

export const DuplicateRecordsModal: React.FC<DuplicateRecordsModalProps> = ({
  open,
  duplicateGroups,
  onConfirm,
  onCancel,
  onKeepAll,
}) => {
  const [selected, setSelected] = useState<{ [key: string]: number }>({});

  const handleSelect = (groupKey: string, idx: number) => {
    setSelected((prev) => ({ ...prev, [groupKey]: idx }));
  };

  const handleConfirm = () => {
    const filled = { ...selected };
    duplicateGroups.forEach((group) => {
      if (filled[group.key] === undefined) {
        filled[group.key] = 0;
      }
    });
    onConfirm(filled);
  };

  const handleKeepAll = () => {
    if (onKeepAll) {
      onKeepAll();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="md"
      fullWidth
      scroll="paper">
      <DialogTitle>Registros Duplicados Encontrados</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: 500 }}>
        <Typography gutterBottom>
          Foram encontrados registros duplicados na importação. Escolha qual
          registro deseja manter para cada grupo:
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {duplicateGroups.map((group) => (
            <Paper key={group.key} sx={{ p: 2 }} variant="outlined">
              <Typography fontWeight={600} gutterBottom>
                Fundo: {group.records[0].cnpj_fundo} | Classe:{' '}
                {group.records[0].subclasse} | Série: {group.records[0].serie}
              </Typography>
              <RadioGroup
                value={selected[group.key] ?? 0}
                onChange={(_, value) => handleSelect(group.key, Number(value))}>
                {group.records.map((record, idx) => (
                  <FormControlLabel
                    key={record.index}
                    value={idx}
                    control={<Radio />}
                    label={`Quantidade: ${record.quantidade} (linha ${record.index + 2})`}
                  />
                ))}
              </RadioGroup>
            </Paper>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        {onKeepAll && (
          <Button onClick={handleKeepAll} variant="outlined" color="secondary">
            Manter todos (cotas individuais)
          </Button>
        )}
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirmar seleção
        </Button>
      </DialogActions>
    </Dialog>
  );
};
